<template>
  <ModalForm
    title="Add Owner"
    :show="props.show"
    @submit="submit"
    @close="emit('close')"
    :processing="form.processing"
  >
    <LabelErrorContainer label="Name">
      <SelectSearch
        instant
        v-model="form.user"
        @search="search"
        :options="options"
        placeholderKey="name"
        v-slot="{ option, selected }"
      >
        <SelectListItemSimple
          :option="option"
          :selected="selected"
          primaryKey="name"
        />
      </SelectSearch>
    </LabelErrorContainer>
  </ModalForm>
</template>

<script setup>
import ModalForm from '@/Common/Overlays/Modals/ModalForm.vue'
import LabelErrorContainer from '@/Common/Forms/Inputs/LabelErrorContainer.vue'
import SelectSearch from '@/Common/Forms/SelectMenus/SelectSearch.vue'
import SelectListItemSimple from '@/Common/Forms/SelectMenus/SelectListItemSimple.vue'
import { ref } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import { Inertia } from '@inertiajs/inertia'

const props = defineProps({
  show: Boolean,
  currentOwners: Array,
  trip: Object,
})

const emit = defineEmits(['close'])

const form = useForm({
  user: null,
})

function submit() {
  form.post(route('trips.add-owner', props.trip), {
    onSuccess: () => {
      emit('close')
      form.reset()
      options.value = []
    },
  })
}

// Search
const options = ref([])

let search = _.debounce(function (query) {
  axios
    .get(route('planes.users.search', props.trip.plane), {
      params: {
        query: query,
        except: props.currentOwners.map((el) => el.id),
        type: 'owners',
      },
    })
    .then((response) => {
      options.value = response.data
    })
    .catch(() => Inertia.reload())
}, 350)
</script>
